export default "__VITE_ASSET__58561e84__"